import update from 'immutability-helper';

const initialState = {
  reportData: {
    from: null,
    to: null,
  },
  dataReceived: false,
};

const RECEIVE_WORK_ORDER_REPORTS_DATA = 'workOrderReports/RECEIVE';

export function receiveWorkOrderReportsData(payload) {
  return { type: RECEIVE_WORK_ORDER_REPORTS_DATA, payload };
}

export default function reducer(state = initialState, action) {
  let { type, payload } = action;

  switch (type) {
    case RECEIVE_WORK_ORDER_REPORTS_DATA:
      return update(state, { reportData: { $set: payload } });
    default:
      return state;
  }
}
